import React from "react";
import { ArrowRight, CalendarClock } from "lucide-react";
import { calendlyUrl, calendlyLinkProps } from "../../lib/calendly";

export default function HomeFinalCTA() {
  return (
    <section
      id="cta"
      data-testid="final-cta-section"
      className="relative py-24 sm:py-32 overflow-hidden"
    >
      <div className="absolute inset-0 bg-grid-faint opacity-50" />
      <div className="absolute inset-0 bg-radial-cyan" />
      <div className="absolute inset-0 bg-radial-lime" />
      <div className="absolute inset-0 bg-grain" />

      <div className="relative max-w-5xl mx-auto px-6 sm:px-10 text-center">
        <div className="inline-flex items-center gap-2 rounded-full border border-[#00E5FF]/25 bg-[#00E5FF]/5 px-3.5 py-1.5 text-[11px] tracking-[0.22em] uppercase font-semibold text-[#00E5FF]">
          <CalendarClock size={13} /> 30-minute audit · no obligation
        </div>

        <h2 className="font-display mt-6 text-[38px] sm:text-[56px] lg:text-[68px] font-semibold tracking-[-0.03em] text-white leading-[1.02]">
          Stop buying tools.
          <br />
          <span className="text-gradient-cyan">
            Start running an <span className="font-serif italic">operation</span>.
          </span>
        </h2>
        <p className="mt-6 text-base sm:text-lg text-slate-400 max-w-2xl mx-auto">
          Get a clear, specialist-led audit of your current recruiting,
          operations, or data workflows. We'll show you where AI
          implementation gives you the biggest lift, and a 90-day plan to get
          there — yours to keep, even if we never work together.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row gap-3 justify-center">
          <a
            href={calendlyUrl()}
            {...calendlyLinkProps}
            data-testid="final-cta-button"
            className="group inline-flex items-center justify-center gap-2 bg-[#00E5FF] hover:bg-[#00E5FF]/90 text-[#050B14] font-semibold px-8 py-4 rounded-md transition-all shadow-[0_0_40px_-8px_rgba(0,229,255,0.7)] hover:shadow-[0_0_50px_-4px_rgba(0,229,255,0.9)]"
          >
            Get My Free Operations Audit
            <ArrowRight size={18} className="arrow-shift" />
          </a>
        </div>

        <div className="mt-10 flex items-center justify-center gap-6 text-xs text-slate-500">
          <span>Replies in &lt; 24h</span>
          <span className="h-1 w-1 rounded-full bg-slate-700" />
          <span>NDA on request</span>
          <span className="h-1 w-1 rounded-full bg-slate-700" />
          <span>No long contracts</span>
        </div>
      </div>
    </section>
  );
}
